<template>
  <div class="qingsu-channnel-container" v-if="Object.keys(pageData).length">
    <qingsuChannelTop
      :progressNum="progressNum"
      @getNavbarHeight="h => (navbarHeight = h)"
    />
    <!-- 提示语 -->
    <!-- <p class="tips" v-if="tips" @click="tips.handler">
      <i class="icon icon-node-website icon-half-price-tip"></i>
      {{ tips.text }}
    </p> -->

    <!-- 用户心声  -->
    <div
      class="qinsu-heart"
      v-if="isShowRate == 1 && heartDataList && heartDataList.length > 0"
    >
      <goodReviews
        :list="heartDataList"
        :title="reviewTitle"
        :moreBtn="+heartDataList.length > 2"
        infoType="userInfo"
      />
    </div>
    <!-- 优惠券 -->
    <Coupon
      v-if="couponList.length"
      :itemType="'home'"
      v-bind="couponList[0]"
      @toUse="filterClick"
    />
    <div
      v-if="listTitle || couponInfo.remaining_places"
      class="list-header"
      :class="{ 'no-list-name': !listTitle }"
    >
      <div class="list-name" v-if="listTitle">
        {{ listTitle }}
      </div>
      <div class="remain-times" v-if="couponInfo.remaining_places">
        剩余 {{ couponInfo.remaining_places }} 次免费倾诉
      </div>
    </div>

    <van-sticky :offset-top="navbarHeight" ref="filter-bar">
      <filter-bar
        class="qingsu-free-filter"
        :items="filterData"
        v-model="filterSelected"
        :theme="'#ff745b'"
        :cols="3"
        style="background-color: #fff"
        :isScroll="false"
        @filterClick="filterClick"
        @itemClick="itemClick"
      />
    </van-sticky>

    <div
      :class="{
        'qingsu-pull-container': true,
        'is-user': userinfo && !qingtingInfo
      }"
    >
      <sortList
        v-if="isShowCharity"
        :list="otherSortList"
        :value="charity"
        @change="id => (charity = id)"
      />

      <list
        class="list"
        :list="teacherList"
        :page="page"
        :size="10"
        @load="loadmore"
        ref="list"
      >
        <template v-for="(item, index) in teacherList">
          <!-- currentTabId !== 1 上线提醒不会显示 -->
          <teacher-item
            :item="item"
            :key="index"
            :hideNums="+channelInfo.type === 1"
            :hidePrice="true"
            :showCharity="isShowCharity"
            @click="onListItemClick(item)"
          />
        </template>

        <listEmpty slot="none" @checkAll="checkAll" />
        <p slot="finished" v-if="+$route.query.custom_channel">已全部加载</p>
      </list>
    </div>

    <transition name="fade">
      <channel-user-fixed-control
        v-if="userinfo && !qingtingInfo && !hideFastEntroy"
        :isLogin="isLogin"
        :isShow="+scrollDirection === 1"
        :onlyFastBtn="true"
        :orderBtnLabel="orderBtnLabel"
        @toOrder="toOrder"
      />
    </transition>
    <transition name="fade">
      <teacher-fixed-control
        v-if="userinfo && qingtingInfo"
        :teacherInfo="qingtingInfo"
      />
      <!-- @refresh="refresh" -->
    </transition>
    <!-- 首次访问、渠道关闭弹窗 -->
    <dialog-channel
      v-if="page_popup && userinfo"
      :page_popup="page_popup"
      :userInfo="userinfo"
      :channelInfo="channelInfo"
      @hide="isCanShowCoupon = true"
    />
    <!-- 优惠券弹窗 -->
    <dialog-coupon
      v-if="isShowCoupon"
      :page_popup="page_popup"
      :couponList="couponList"
      :userInfo="userinfo"
      @toUse="filterClick"
    />
    <tabbar ref="tabbar" :disabled="toWechatAuth && !userinfo?.id" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import dataStore from 'store/qingsu/channel'
import filterBar from 'component/common/filter-bar'
import teacherFixedControl from 'component/qingsu/teacherFixedControl'
import TeacherItem from 'component/qingsu/indexV3/teacherItem.vue'
import qingsuCommonMixin from 'mixins/qingsu/common.js'
import qingsuindex from 'store/qingsu/index'
import qingsuChannelTop from 'component/qingsu/qingsuChannelTop.vue'
import listEmpty from 'component/qingsu/listEmpty'
import ChannelUserFixedControl from 'component/qingsu/channel/channelUserFixedControl'
import pageMixin from 'app/web/mixins/page.js'
import { Sticky } from 'vant'
import sortList from 'app/web/component/common/sortList.vue'
import list from 'app/web/component/common/list.vue'
import directionScroll from 'app/web/mixins/directionScroll.js'
import { getScrollTop } from 'app/frontend-lib/tools/utils.js'
import goodReviews from 'component/qingsu/home/goodReviews'
import qingsuHeart from 'store/qingsu/heart'
import { setCookie } from 'lib/tools/cookies'
import wechatLogin from 'app/web/mixins/wechatLogin.js'
import DialogChannel from 'component/qingsu/channel/dialogChannel'
import DialogCoupon from 'component/qingsu/channel/dialogCoupon'
import Coupon from 'component/qingsu/channel/coupon'
import Tabbar from 'component/qingsu/channel/tabbar'
import { loginWithAuthKey, businessUserCheck } from 'api/qingsu'
import qs from 'qs'
import configStore from 'app/web/store/common/config.js'

import channel from 'app/web/mixins/qingsu/channel.js'

export default {
  dataStore: [
    qingsuindex,
    dataStore,
    qingsuHeart,
    { name: 'qingsuChannelConfig', store: configStore.store }
  ],
  mixins: [pageMixin, qingsuCommonMixin, directionScroll, wechatLogin, channel],
  components: {
    filterBar,
    teacherFixedControl,
    TeacherItem,
    ChannelUserFixedControl,
    qingsuChannelTop,
    [Sticky.name]: Sticky,
    sortList,
    listEmpty,
    list,
    goodReviews,
    DialogChannel,
    DialogCoupon,
    Coupon,
    Tabbar
  },
  data() {
    return {
      filterSelected: ['default', '0', '0'],
      navbarHeight: 50,
      charity: 0,
      page: 1,
      reviewTitle: '用户心声',
      progressNum: 0, // 用户进行中订单数
      isCanShowCoupon: false //优先级：渠道关闭>首次访问>优惠券
    }
  },
  preFetch({ store, route }) {
    return Promise.all([
      store.dispatch('qingsuchannel/fetchIndex', {
        out_channel_id: route.query.cid
      }),
      store.dispatch('qingsuindex/fetchIndex'),
      store.dispatch('qingsuChannelConfig/fetchConfig', {
        configureCode: 'qingsu-channel-config'
      })
    ])
      .then(([res]) => {
        // 渠道不存在
        if (res.code === 20002 || !res.data.out_channel) {
          // eslint-disable-next-line
          const { cid, ...otherQuery } = route.query
          const queryStr = Object.keys(otherQuery) // 去掉cid 避免首页和渠道来回302
            .map((k, i) => (i === 0 ? '?' : '&') + `${k}=${route.query[k]}`)
            .reduce((all, v) => all + v, '')
          return Promise.reject({
            code: 302,
            data: {
              url: '/qingsu' + queryStr
            }
          })
        }
        let title = '倾诉渠道'
        if (
          res.code === 0 &&
          res.data.channel_page_info &&
          res.data.channel_page_info.page_title
        ) {
          title = res.data.channel_page_info.page_title
        }
        // reset title
        store.commit('setMeta', { title })
      })
      .then(() =>
        Promise.all([
          store.dispatch('qingsuchannel/fetchTeacherList', {
            cid: route.query.cid,
            page: 1
          }),
          store.dispatch('qingsuchannel/fetchAds', {
            channel_id: route.query.cid
          }),
          store.dispatch('qingsuHeart/qingsuHeartList', {
            page: 1,
            cid: route.query.cid
          })
        ])
      )
  },
  async mounted() {
    let { cid, channel_flag, authKey } = this.$route.query
    // 如果带有加密手机号参数，则先去登录
    if (authKey && cid) {
      authKey = decodeURIComponent(authKey)
      await loginWithAuthKey({
        cid,
        authKey
      })
      location.replace(
        location.origin +
          location.pathname +
          '?' +
          qs.stringify({
            cid,
            channel_flag
          })
      )
    }
    // 因为渠道信息接口有用户信息，所以重新请求一次
    this.$store.dispatch('qingsuchannel/fetchIndex', {
      out_channel_id: this.$route.query.cid
    })
    // 女神节活动
    ;(this.toWechatAuth ? this.login() : Promise.resolve()).then(() => {
      this.$store.dispatch('getUserInfo', true).then(() => {
        if (this.qingtingInfo) {
          this.$watch('qingtingInfo', () => {
            this.loadmore(1).then(() => {
              window.scrollTo(0, 0)
              this.$refs['qingsu-pull-container'].refresh()
            })
          })
        }
        this.fetchCoupon()
      })
    })
    this.$store.dispatch('qingsuindex/fetchIsQsBusinessNewUser', {
      cid: this.$route.query.cid
    })
    this.$store
      .dispatch('qingsuindex/fetchUserMessage', {
        order_cid: +this.$route.query.custom_channel
          ? this.$route.query.cid
          : ''
      })
      .then(async res => {
        this.progressNum = res.progress_num || 0
        this.$refs.tabbar.setBadge('order', this.progressNum)
      })

    if (cid) {
      setCookie({
        key: 'qingsu_cooperation_channel',
        value: cid,
        timeMinSec: 24 * 60 * 60 * 1000,
        domain: document.domain.split('.').slice(-2).join('.')
      })
    }

    if (!this.isDisableShare) {
      this.setNativeShare()
    }

    this.$bridge.switchNavigationBar({
      isHidden: 0
    })
    this.$trackPageView('listen_channel_view', {
      channel_id: cid,
      cid,
      channel_flag
    })
  },
  computed: {
    ...mapGetters(['isLogin', 'qingtingInfo']),
    ...mapState(['userinfo']),
    teacherList() {
      return this.$store.state.qingsuchannel.teacherList
    },
    filterData() {
      return this.$store.getters['qingsuindex/filterData']
    },
    pageData() {
      return this.$store.state.qingsuchannel.index.channel_page_info
    },
    channelInfo() {
      return this.$store.state.qingsuchannel.index.out_channel_info
    },
    page_popup() {
      return this.$store.state.qingsuchannel.index.page_popup
    },
    couponInfo() {
      return this.$store.state.qingsuchannel.couponInfo
    },

    orderBtnLabel() {
      let { order_name } = this.pageData
      const { type } = this.channelInfo
      if (!order_name) {
        order_name = Number(type) === 1 ? '免费公益倾诉' : '一键倾诉'
      }
      return order_name
    },

    isDisableShare() {
      return +this.$route.query.cid === 363
    },

    hideAllNonBaseMenuItemConfig() {
      return this.isDisableShare
        ? { hideAllNonBaseMenuItem: true }
        : { hideAllNonBaseMenuItem: false }
    },

    shareConfig() {
      let title = this.$store.state.meta.title
      let link =
        +this.$route.query.custom_channel === 1
          ? undefined
          : this.$mZXSafeOrigin + '/qingsu/channel?cid=' + this.$route.query.cid
      let imgUrl = this.pageData ? this.pageData.logo : ''
      let defaultUrl =
        'https://ossimg.xinli001.com/20200127/86251c382b4d7e1b7d8c7a0eb4aaafa6.png'
      let desc =
        this.pageData.share_description ||
        '专业心理咨询师，为你提供情绪疏导服务。'

      return {
        title,
        desc,
        link,
        imgUrl: imgUrl || defaultUrl
      }
    },

    hideFastEntroy() {
      return +this.channelInfo.is_open_onekey_qingsu === 0
    },

    // tips() {
    //   const { is_use_zero_experience_qingsu_id } = this.channelInfo
    //   if (is_use_zero_experience_qingsu_id) {
    //     return {
    //       text: '您此前已参与过免费倾诉，下单将以原价付费。查看>',
    //       handler: () => {
    //         this.routerToStaicWithoutNav({
    //           path: '/qingsu-order-detail',
    //           query: {
    //             id: is_use_zero_experience_qingsu_id,
    //             cid: this.$route.query.cid
    //           }
    //         })
    //       }
    //     }
    //   }
    //   return null
    // },

    otherSortList() {
      return [
        { id: 0, text: '默认' },
        { id: 1, text: '0元公益' }
      ]
    },

    isShowCharity() {
      return this.$store.state.qingsuindex.showCharity
    },

    filterParams() {
      const { filterSelected, charity, $route } = this
      return {
        sort: filterSelected[0],
        category: filterSelected[1],
        gender: filterSelected[2],

        cid: $route.query.cid,
        charity
      }
    },
    // 心声数据
    heartDataList() {
      return this.$store.state['qingsuHeart'].heartData
    },
    // 是否显示用户心声
    isShowRate() {
      return this.$store.state['qingsuHeart'].is_show_rate
    },

    is2022WomansDayActivity() {
      const { cid } = this.$route.query
      return +cid === 209
    },
    listTitle() {
      return this.pageData.list_title || ''
    },
    couponList() {
      return this.couponInfo.coupon
    },
    isShowCoupon() {
      if (!this.page_popup || !this.couponList.length) {
        return false
      }
      return this.isCanShowCoupon && +this.page_popup.paid_coupon_popup
    },
    //是否B端渠道
    isBusinessChannel() {
      const { type } = this.channelInfo
      return +type === 4
    }
  },
  methods: {
    loadmore(page, callback) {
      return this.$store
        .dispatch(`qingsuchannel/fetchTeacherList`, {
          page,
          ...this.filterParams
        })
        .then(data => {
          callback(data.length < 10)
          if (data.length >= 10) {
            this.page = page
          }
        })
    },

    checkAll() {
      this.filterSelected = ['default', '0', '0']
    },

    async toOrder() {
      if (this.isLogin && this.isBusinessChannel) {
        const isPass = await this.checkBusinessUser()
        if (!isPass) {
          return
        }
      }
      this.toFastOrder(this.getChannelRouteToQuerys()).catch(res => {
        if (res.code === -10) {
          this.$stat.send(`倾诉-首页「当前无倾听师」提示`)
        }

        if (res.code === -10 || res.code === -11) {
          this.$toast({
            text: res.message
          })
        }
      })
    },
    // 点击筛选滚动顶部
    filterClick() {
      let th = this.$refs['list'].$el.getBoundingClientRect().top
      let st = getScrollTop()
      window.scrollTo(0, st + th - 92)
    },

    onListItemClick(item) {
      const { cid, channel_flag } = this.$route.query
      this.$trackEvent('listen_channel_click', {
        listener_id: item.user_id,
        listener_name: item.nickname || '',
        channel_id: cid,
        cid,
        channel_flag
      })
      if (this.is2022WomansDayActivity) {
        this.routerToStaic({
          path: '/qingsu-order-page',
          query: {
            cid: this.$route.query.cid,
            channel_flag: this.$route.query.channel_flag || '',
            to_user_id: item.user_id,
            ...this.getChannelRouteToQuerys()
          }
        })
      } else {
        this.eventStat('老师列表-点击老师')
        this.toTeacherDetail(item)
      }
    },
    itemClick() {
      const { cid = '', channel_flag = '' } = this.$route.query
      let params = {
        filter_item: [],
        filter: [],
        channel_id: cid,
        cid,
        channel_flag
      }
      const { category = '', gender = '', sort = '' } = this.filterParams
      if (category) {
        let arr = this.filterData.find(v => v.stat == '方向')
        const res = arr.child.find(v => v.key === category)
        params.filter.push(res.label)
        params.filter_item.push('方向')
      }
      if (gender) {
        let arr = this.filterData.find(v => v.stat == '性别')
        const res = arr.child.find(v => v.key === gender)
        params.filter.push(res.label)
        params.filter_item.push('性别')
      }
      if (sort) {
        let arr = this.filterData.find(v => v.stat == '排序')
        const res = arr.child.find(v => v.key === sort)
        params.filter.push(res.label)
        params.filter_item.push('排序')
      }
      params.filter_item = [...new Set(params.filter_item)]
      params.filter = [...new Set(params.filter)].toString()
      this.$trackEvent('listen_channel_filter_click', params)
    },
    fetchCoupon() {
      const { cid, cpChannelId } = this.$route.query
      this.$store
        .dispatch('qingsuchannel/fetchCoupon', {
          cid,
          cp_channel_id: cpChannelId
        })
        .then(() => {
          if (this.couponList.length) {
            this.$refs.tabbar.setBadge('mine', this.couponList.length)
          }
        })
    },
    async checkBusinessUser() {
      const { cid, cpChannelId } = this.$route.query
      const { code } = await businessUserCheck({
        cid,
        cp_channel_id: cpChannelId
      })
      if (+code === 82001) {
        this.$dialog({
          title: '抱歉，暂无可预约次数。',
          buttons: [
            {
              label: '前往壹心理倾诉',
              onClick: () => {
                this.routerPush(
                  'https://m.xinli001.com/qingsu?hideNavigationBar=1&channel_flag=tob_wjc'
                )
              }
            }
          ]
        })
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    filterParams: {
      handler() {
        this.page = 1
        this.$refs['list'].refresh()
        window.scrollTo(
          0,
          this.$refs['filter-bar'].$el.offsetTop - this.navbarHeight
        )
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.qingsu-channnel-container {
  background: #fff;
  .qingsu-channel-top {
    & + .list-header {
      margin-top: 50px;
    }
    & + .coupon {
      margin-top: 60px;
    }
  }
  .qingsu-channel-top-navbar {
    background: #fff;
  }
  .tips {
    width: 690px;
    height: 86px;
    box-sizing: border-box;
    margin: 0 auto;
    line-height: 86px;
    background: #fbf2e3;
    border-radius: 20px;
    font-size: 24px;
    color: #ffa202;
    padding-left: 30px;
    margin-bottom: 30px;
    i {
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .qinsu-heart {
    padding: 0 30px;
    margin-top: 30px;
    background-color: #fff;
  }
  .list {
    min-height: calc(100vh - 100px);
  }
  .list-header {
    @include flex(row, flex-start, baseline);
    padding: 0px 30px 0;
    &.no-list-name {
      @include flex(row, center, baseline);
    }
  }
  .list-name {
    font-size: 46px;
    font-weight: bold;
    color: #21252d;
    font-weight: bold;
    background: #fff;
    margin-right: 50px;
  }
  .remain-times {
    color: #ff745b;
    font-size: 26px;
    font-weight: 400;
  }
  .van-sticky--fixed {
    width: pxToRem(750);
    left: 50%;
    margin-left: pxToRem(-375);
  }
  .qingsu-pull-container {
    background: #fff;
    padding: 0 30px;
    // &.is-user {
    //   min-height: calc(100vh - 100px);
    // }
  }
  .fixed-wrap {
    margin-bottom: env(safe-area-inset-bottom);
    bottom: 129px !important;
  }
}
</style>
